/* RefineDropdownItems.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["triggerRef"];
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/** @jsxFrag */
import { useIntl } from 'react-intl-next';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import ChevronRightIcon from '@atlaskit/icon/utility/migration/chevron-right';
export function RefineDropdownItems(_ref) {
  var items = _ref.items,
    onItemClick = _ref.onItemClick,
    currentOpenedSubMenu = _ref.currentOpenedSubMenu,
    onSubMenuOpenChanged = _ref.onSubMenuOpenChanged;
  return /*#__PURE__*/React.createElement(DropdownItemGroup, null, items.map(function (item) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.title.id,
      item: item,
      onItemClick: onItemClick,
      currentOpenedSubMenu: currentOpenedSubMenu,
      onSubMenuOpenChanged: onSubMenuOpenChanged
    });
  }));
}
function Item(_ref2) {
  var item = _ref2.item,
    onItemClick = _ref2.onItemClick,
    currentOpenedSubMenu = _ref2.currentOpenedSubMenu,
    onSubMenuOpenChanged = _ref2.onSubMenuOpenChanged;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  if ('children' in item && item.children) {
    var handleOpenChange = function handleOpenChange(_ref3) {
      var isOpen = _ref3.isOpen;
      onSubMenuOpenChanged === null || onSubMenuOpenChanged === void 0 || onSubMenuOpenChanged(item, isOpen);
    };
    return /*#__PURE__*/React.createElement(DropdownMenu, {
      placement: "right-start",
      shouldRenderToParent: true,
      isOpen: currentOpenedSubMenu === item,
      onOpenChange: handleOpenChange,
      trigger: function trigger(_ref4) {
        var triggerRef = _ref4.triggerRef,
          triggerProps = _objectWithoutProperties(_ref4, _excluded);
        return /*#__PURE__*/React.createElement(DropdownItem
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        , _extends({}, triggerProps, {
          ref: triggerRef,
          elemBefore: item.icon,
          elemAfter: /*#__PURE__*/React.createElement(ChevronRightIcon, {
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
          })
        }), /*#__PURE__*/React.createElement("span", null, formatMessage(item.title)));
      }
    }, /*#__PURE__*/React.createElement(DropdownItemGroup, null, /*#__PURE__*/React.createElement(RefineDropdownItems, {
      items: item.children,
      onItemClick: onItemClick
    })));
  }
  var handleItemClick = function handleItemClick() {
    var _item$onClick;
    onItemClick();
    (_item$onClick = item.onClick) === null || _item$onClick === void 0 || _item$onClick.call(item);
  };
  return /*#__PURE__*/React.createElement(DropdownItem, {
    elemBefore: item.icon,
    onClick: handleItemClick
  }, formatMessage(item.title));
}